// External Libraries
import gql from 'graphql-tag';

//Internal Modules
import {
  FUNDING_OPTIONS_FRAGMENT,
  THREE_DS_2_CONTINGENCY_FRAGMENT,
} from '../fragments';

export const ONBOARD_GUEST_MUTATION = gql`
  mutation OnboardGuestMutation(
    $bank: BankAccountInput
    $billingAddress: AddressInput
    $card: CardInput
    $country: CountryCodes
    $currencyConversionType: CheckoutCurrencyConversionType
    $dateOfBirth: DateOfBirth
    $email: String
    $firstName: String!
    $lastName: String!
    $phone: PhoneInput
    $shareAddressWithDonatee: Boolean
    $shippingAddress: AddressInput
    $supportedThreeDsExperiences: [ThreeDSPaymentExperience]
    $token: String!
  ) {
    onboardAccount: onboardGuest(
      bank: $bank
      billingAddress: $billingAddress
      card: $card
      country: $country
      currencyConversionType: $currencyConversionType
      dateOfBirth: $dateOfBirth
      email: $email
      firstName: $firstName
      lastName: $lastName
      phone: $phone
      shareAddressWithDonatee: $shareAddressWithDonatee
      shippingAddress: $shippingAddress
      token: $token
    ) {
      buyer {
        auth {
          accessToken
        }
        userId
      }

      flags {
        is3DSecureRequired
      }

      ...fundingOptions

      paymentContingencies {
        threeDomainSecure(experiences: $supportedThreeDsExperiences) {
          status
          redirectUrl {
            href
          }
          method
          parameter
          experience
          requestParams {
            key
            value
          }
        }
        ...threeDSContingencyData
      }
    }
  }
  ${FUNDING_OPTIONS_FRAGMENT}
  ${THREE_DS_2_CONTINGENCY_FRAGMENT}
`;
